module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-09-ada8fec7.svg";